import { Icon } from '@superhi/design'
import React from 'react'

export const SIZE = { small: 24, medium: 28, large: 32 }

const Wilson: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Icon key={2} name="wilson" color="BLUE_50" size={SIZE} />
)

export default Wilson
